import Badge from '../ui/Badge'

const TONE = { low: 'default', medium: 'warning', high: 'danger' }

export default function PriorityBadge({ priority, className }) {
    if (!priority) return null
    return (
        <Badge tone={TONE[priority] || 'default'} className={className}>
            {priority}
        </Badge>
    )
}
